import Home from './views/Home.vue'

import Login from './views/Login.vue'
import EditProfile from './views/EditProfile.vue'

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

import Workspace from './components/Workspace.vue'
import NotFoundComponent from './components/NotFoundComponent.vue'
import UserManagement from "./views/UserManagement";
import WorkspaceManagement from "./views/WorkspaceManagement";

export const routes = [
  {
    path: '',
    props: true,
    name: 'home',
    components: {
      default: Home,
      'header-top': Header,
      'header-bottom': Footer
    }
  },
  {path: '/login', component: Login, name: 'login'},
  {
    path: '/edit-profile',
    components: {
      default: EditProfile,
      'header-top': Header,
      'header-bottom': Footer
    }
  },
  {
    path: '/user-management',
    components: {
      default: UserManagement,
      'header-top': Header,
      'header-bottom': Footer
    }
  },
  {
    path: '/:workspace_name/:workspace_id/:app_name/:app_id/',
    components: {
      default: Workspace,
      'header-top': Header,
      'header-bottom': Footer
    }
  },
  {
    path: '/:workspace_name/:workspace_id/workspace_management/',
    components: {
      default: WorkspaceManagement,
      'header-top': Header,
      'header-bottom': Footer
    }
  },
  // 404 PAGE
  {
    path: '*',
    components: {
      default: NotFoundComponent,
      'header-top': Header,
      'header-bottom': Footer
    }
  },

  // redirect
  {path: '/redirect-me-to-home', redirect: {name: 'home'}},
  // {path: '/redirect-me', redirect: '/user'},
  // generic catch all route
  {path: '*', redirect: '/'}
]



// WEBPACK FOOTER //
// ./src/routes.js